/**
 * WARNING: DO NOT EDIT
 * This file is auto-generated and updated by codegen
 */
import { PHDocumentController } from "document-model";
import { VetraPackage } from "../module.js";
import type { VetraPackageAction, VetraPackagePHState } from "./types.js";

export const VetraPackageController = PHDocumentController.forDocumentModel<
  VetraPackagePHState,
  VetraPackageAction
>(VetraPackage);
